import { Box, Skeleton } from "@mui/material";
import React, { Component } from "react";
import Tooltip from "../Tooltip";

export default class TextOverflow extends Component<any, any> {
  static defaultProps = {
    justifyContent: null,
    skeletonWidth: "100px",
  };

  renderText() {
    const { sx, children, centered, loading, skeletonWidth } = this.props;

    return (
      <Box
        className="klayo-textoverflow"
        sx={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          padding: "0 16px",
          whiteSpace: "nowrap",
          width: "100%",
          justifyContent: loading && centered ? "center" : null,
          display: loading ? "flex" : "block",
          ...sx,
        }}
      >
        {loading ? <Skeleton width={skeletonWidth} /> : children}
      </Box>
    );
  }

  render() {
    const { tooltip } = this.props;
    return tooltip ? (
      <Tooltip title={tooltip}>{this.renderText()}</Tooltip>
    ) : (
      this.renderText()
    );
  }
}
